"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstantField = void 0;
const date_time_field_1 = require("../date-time-field/date-time-field");
exports.InstantField = date_time_field_1.DateTimeField;
//# sourceMappingURL=instant-field.js.map